import React from 'react';
import { Box, Container, Typography, Grid, Card, CardContent, Button } from '@mui/material';
import { ArrowForward, OpenInNew } from '@mui/icons-material';
import tenDLogo from '../assets/cropped_circle_image.png';
import mgLogo from '../assets/mg_fintech_logo_user.jpg';

const MGFintechShowcase = () => {
    const products = [
        {
            name: 'UrLawyers',
            description: 'Instant legal consultation platform connecting clients with verified lawyers',
            logo: 'https://www.urlawyers.in/images/logo/logo-icon.png',
            link: 'https://www.urlawyers.in'
        },
        {
            name: 'InCallers',
            description: 'Business calling and CRM platform for efficient communication management',
            logo: 'https://www.incallers.com/InCallers.png',
            link: 'https://www.incallers.com'
        },
        {
            name: '10D Stores',
            description: 'Hyperlocal store management connecting businesses with value-conscious customers',
            logo: tenDLogo,
            link: '/',
            badge: 'Current Platform'
        },
        {
            name: 'BRESA',
            description: 'India\'s first verified all-in-one real estate super-app platform',
            logo: 'https://www.bresa.in/BRESALOGO.png',
            link: 'https://www.bresa.in'
        }
    ];

    return (
        <Box sx={{ backgroundColor: '#0f172a', color: 'white', py: 10, textAlign: 'center' }}>
            <Container maxWidth="lg">
                {/* Header Section */}
                <Box sx={{ mb: 8, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                    <Box
                        sx={{
                            width: 100,
                            height: 100,
                            backgroundColor: 'white',
                            borderRadius: '50%',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            mb: 3,
                            boxShadow: '0 0 20px rgba(255,255,255,0.1)',
                            overflow: 'hidden',
                            p: 2
                        }}
                    >
                        <img
                            src={mgLogo}
                            alt="MG Fintech Logo"
                            style={{ width: '100%', height: '100%', objectFit: 'contain' }}
                        />
                    </Box>

                    <Typography variant="h4" component="h2" sx={{ fontWeight: 700, mb: 2, color: '#ffffff' }}>
                        Powered by MG Fintech
                    </Typography>

                    <Typography variant="body1" sx={{ color: '#ffffff', maxWidth: '700px', mb: 3, lineHeight: 1.6 }}>
                        MG Fintech Software Solutions Pvt Ltd builds innovative digital platforms across legal-tech, prop-tech, CRM, and retail-tech domains.
                    </Typography>

                    <Button
                        component="a"
                        href="https://mgfintech.com"
                        target="_blank"
                        rel="noopener noreferrer"
                        endIcon={<OpenInNew sx={{ fontSize: 16 }} />}
                        sx={{
                            color: '#3b82f6',
                            textTransform: 'none',
                            fontWeight: 600,
                            '&:hover': { backgroundColor: 'transparent', textDecoration: 'underline' }
                        }}
                    >
                        Visit MG Fintech
                    </Button>
                </Box>

                {/* Products Grid */}
                <Grid container spacing={3}>
                    {products.map((product) => (
                        <Grid item xs={12} md={3} key={product.name}>
                            <Card
                                sx={{
                                    backgroundColor: 'rgba(30, 41, 59, 0.5)',
                                    border: '1px solid rgba(255,255,255,0.1)',
                                    borderRadius: 2,
                                    height: '100%',
                                    textAlign: 'left',
                                    transition: 'all 0.3s ease',
                                    '&:hover': {
                                        transform: 'translateY(-5px)',
                                        borderColor: '#3b82f6',
                                        backgroundColor: 'rgba(30, 41, 59, 0.8)'
                                    }
                                }}
                            >
                                <CardContent sx={{ p: 3, display: 'flex', flexDirection: 'column', height: '100%' }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                                        <Box
                                            sx={{
                                                width: 40,
                                                height: 40,
                                                backgroundColor: 'white',
                                                borderRadius: 1,
                                                display: 'flex',
                                                alignItems: 'center',
                                                justifyContent: 'center',
                                                mr: 2,
                                                p: 0.5
                                            }}
                                        >
                                            <img
                                                src={product.logo}
                                                alt={`${product.name} logo`}
                                                style={{ maxWidth: '100%', maxHeight: '100%', objectFit: 'contain' }}
                                            />
                                        </Box>
                                        <Box>
                                            <Typography variant="h6" sx={{ fontWeight: 700, fontSize: '1rem', lineHeight: 1.2, color: '#ffffff' }}>
                                                {product.name}
                                            </Typography>
                                            {product.badge && (
                                                <Typography variant="caption" sx={{ color: '#3b82f6', fontWeight: 600, fontSize: '0.7rem' }}>
                                                    {product.badge}
                                                </Typography>
                                            )}
                                        </Box>
                                    </Box>

                                    <Typography variant="body2" sx={{ color: '#ffffff', mb: 3, flexGrow: 1, fontSize: '0.875rem', lineHeight: 1.5 }}>
                                        {product.description}
                                    </Typography>

                                    {/* Only show Visit Site if it's not the current site (10D Stores) */}
                                    {product.name !== '10D Stores' && (
                                        <Button
                                            component="a"
                                            href={product.link}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                            endIcon={<ArrowForward sx={{ fontSize: 16 }} />}
                                            sx={{
                                                color: '#3b82f6',
                                                textTransform: 'none',
                                                fontWeight: 600,
                                                p: 0,
                                                justifyContent: 'flex-start',
                                                '&:hover': { backgroundColor: 'transparent', gap: 1 }
                                            }}
                                        >
                                            Visit Site
                                        </Button>
                                    )}
                                </CardContent>
                            </Card>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    );
};

export default MGFintechShowcase;
